<template>
    <SOSlotModal
    modal-title="Hapus Jenis Item"
    :modal-id="id"
    :no-padding="true"
    @close="close()"
    >
        <template v-slot:modal-body>
            <div class="p-l-24 p-r-24">
                <div class="f-14">
                    <p>Apakah anda yakin ingin menghapus item <b>{{ data.nama }}</b> ?</p>
                </div>
            </div>
        </template>
        <template v-slot:modal-footer>
            <div class="p-r-24 p-l-24">
                <div class="p-d-24">
                    <SOButton
                        :text="'Hapus'"
                        :outline="true"
                        :loading="isLoading"
                        :disable="isLoading"
                        :full="true"
                        @action="deleteItem()"
                    />
                </div>
            </div>
        </template>
    </SOSlotModal>
</template>
<script>
import conn from "@/store/utils/connection";
import SOSlotModal from "@/so-components/global/slot/SOSlotModal";
import SOButton from "@/so-components/global/ui/SOButton";

export default {
    name: "DetailitemModalHapus",
    components: {
        SOSlotModal,
        SOButton
    },
    data() {
        return {
            id: "modal-hapus",
            data: {},
            isLoading: false
        }
    },
    methods: {
        open(item) {
            this.data = item
            $("#" + this.id).modal("show");
        },
        close() {
            $("#" + this.id).modal("hide");
            setTimeout(() => {
                this.$emit("close");
            }, 500);
        },
        async deleteItem() {
            const form = new FormData
            form.append("iditem", this.data.iditem);
            this.isLoading = true
            try {
                const res = await conn.post(this.$baseurl + ('masterData/item/delete_item'), form, conn.contentType.form)
                console.log(res);
                this.$emit("finishedDelete")
                $("#" + this.id).modal("hide");
            } catch (error) {
                this.$toast.error(error);
            }
            this.isLoading = false
        }
    }
}
</script>